module.exports = __webpack_public_path__ + "static/img/6.e14ca19.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dww/6.png
// module id = Mike
// module chunks = 0